"use strict";

globalThis.Hologram.pendingScripts ??= [];

globalThis.Hologram.pendingScripts.push({
  digest: new URL(document.currentScript.src).pathname.match(/-([^-]+)\.js$/)[1],
  define: (deps) => {
    const {
      Bitstring,
      ERTS,
      HologramBoxedError,
      HologramInterpreterError,
      Interpreter,
      MemoryStorage,
      Type,
      Utils,
    } = deps;

Interpreter.defineElixirFunction("Macro.Env", "__struct__", 0, "public", [{params: (context) => [], guards: [], body: (context) => {
return Type.map([[Type.atom("__struct__"), Type.atom("Elixir.Macro.Env")], [Type.atom("aliases"), Type.list([])], [Type.atom("context"), Type.atom("nil")], [Type.atom("context_modules"), Type.list([])], [Type.atom("file"), Type.bitstring("nofile")], [Type.atom("function"), Type.atom("nil")], [Type.atom("functions"), Type.list([])], [Type.atom("lexical_tracker"), Type.atom("nil")], [Type.atom("line"), Type.integer(0n)], [Type.atom("macro_aliases"), Type.list([])], [Type.atom("macros"), Type.list([])], [Type.atom("module"), Type.atom("nil")], [Type.atom("requires"), Type.list([])], [Type.atom("tracers"), Type.list([])], [Type.atom("versioned_vars"), Type.map([])]]);
}}]);

Interpreter.defineElixirFunction("Macro.Env", "__struct__", 1, "public", [{params: (context) => [Type.variablePattern("kv_0")], guards: [], body: (context) => {
return Erlang_Lists["foldl/3"](Type.anonymousFunction(2, [{params: (context) => [Type.tuple([Type.variablePattern("key_1"), Type.variablePattern("val_2")]), Type.variablePattern("acc_3")], guards: [], body: (context) => {
return Elixir_Map["merge/2"](context.vars.acc_3, Type.map([[context.vars.key_1, context.vars.val_2]]));
}}], context, "-__struct__/1-fun-0-"), Type.map([[Type.atom("__struct__"), Type.atom("Elixir.Macro.Env")], [Type.atom("aliases"), Type.list([])], [Type.atom("context"), Type.atom("nil")], [Type.atom("context_modules"), Type.list([])], [Type.atom("file"), Type.bitstring("nofile")], [Type.atom("function"), Type.atom("nil")], [Type.atom("functions"), Type.list([])], [Type.atom("lexical_tracker"), Type.atom("nil")], [Type.atom("line"), Type.integer(0n)], [Type.atom("macro_aliases"), Type.list([])], [Type.atom("macros"), Type.list([])], [Type.atom("module"), Type.atom("nil")], [Type.atom("requires"), Type.list([])], [Type.atom("tracers"), Type.list([])], [Type.atom("versioned_vars"), Type.map([])]]), context.vars.kv_0);
}}]);
  },
});

document.dispatchEvent(new CustomEvent("hologram:scriptLoaded"));